import React, { useEffect } from 'react';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { useFirebaseAuth } from '../hooks/useFirebaseAuth';

interface FirebaseProviderProps {
  children: React.ReactNode;
  firebase: any;
  config: any;
  dispatch: any;
  createFirestoreInstance?: any;
}

// Wrapper component to properly integrate Firebase v12 with react-redux-firebase v3
export const FirebaseProvider: React.FC<FirebaseProviderProps> = ({
  children,
  firebase,
  config,
  dispatch,
  createFirestoreInstance = undefined,
}) => {
  // Initialize Firebase auth state listener
  useFirebaseAuth();

  return (
    <ReactReduxFirebaseProvider
      firebase={firebase}
      config={config}
      dispatch={dispatch}
      createFirestoreInstance={createFirestoreInstance}
    >
      {children}
    </ReactReduxFirebaseProvider>
  );
};